<script lang="ts" setup>
  import { computed } from 'vue'

  import SvgIcon from '@shared/components/svg-icon.vue'

  import type { HMSPeer } from '@100mslive/hms-video-store'

  const props = withDefaults(
    defineProps<{
      peer: HMSPeer
      isDisplayedPeerName: boolean
      isVideo: boolean
      isAudio: boolean
      isPInPMode?: boolean
      isMaximizeButton?: boolean
      isPinButton?: boolean
      isPinned?: boolean
    }>(),
    {
      isPInPMode: false,
      isMaximizeButton: false,
      isPinButton: false,
      isPinned: false,
    }
  )

  const emit = defineEmits(['on-context-menu', 'on-maximize', 'on-pin'])

  const peerName = computed(() => (props.peer.isLocal ? `${props.peer.name} (You)` : props.peer.name))
  const maximizeButtonHandler = () => {
    emit('on-maximize')
  }
  const pinButtonHandler = () => {
    emit('on-pin', props.peer)
  }
</script>

<template>
  <div class="meeting-peer" :class="{ 'tw-bg-black': !isPInPMode }">
    <video
      :id="peer.videoTrack"
      :key="peer.videoTrack"
      class="tw-mx-auto tw-bg-black video-placeholder-text md:tw-rounded-8 tw-h-full"
      :class="{ 'tw-rounded-8 tw-w-full tw-max-h-[175px]': isPInPMode }"
      autoplay
      playsinline
      muted
      click-outside-caller
    />
    <span
      v-if="isDisplayedPeerName"
      class="tw-p-4 tw-text-placeholder-2 tw-text-grey-100 tw-bg-other-1000 tw-rounded-4 tw-max-w-max tw-absolute tw-bottom-12 tw-left-12"
    >
      {{ peerName }}
    </span>
    <span v-if="!isAudio" class="tw-absolute tw-top-12 tw-right-12">
      <svg-icon class="tw-fill-white" name="microphone-off_plain" size="24" />
    </span>
    <span
      v-if="!isVideo"
      class="tw-text-grey-100 tw-text-subtitle-1 tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-[50%] -tw-translate-y-[50%]"
    >
      Video off
    </span>
    <button
      v-if="isMaximizeButton && isPInPMode"
      class="peer-wrapper__maximize md:tw-hidden tw-absolute tw-bottom-8 tw-right-8 tw-z-10"
      @click="maximizeButtonHandler"
    >
      <svg-icon name="maximize" size="24" class="tw-fill-white" />
    </button>
    <button
      v-if="isPinned"
      class="tw-flex tw-absolute tw-top-8 tw-left-8 tw-z-10 tw-bg-white tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center tw-rounded-4"
      @click="pinButtonHandler"
    >
      <svg-icon name="pin-needle" size="24" class="tw-fill-primary-100" />
    </button>
    <button
      v-if="isPinButton"
      class="meeting-peer__pin tw-hidden tw-absolute tw-top-[50%] tw-left-[50%] tw-z-10 -tw-translate-y-1/2 -tw-translate-x-1/2 tw-bg-grey-110 tw-h-[44px] tw-w-[44px] tw-items-center tw-justify-center tw-rounded-4"
      @click="pinButtonHandler"
    >
      <svg-icon name="pin-needle" size="28" class="tw-fill-white" />
    </button>
  </div>
</template>

<style lang="scss">
  .meeting-peer {
    &:hover {
      .meeting-peer__pin {
        @apply tw-flex;
      }
    }
  }
</style>
